module.exports = __webpack_public_path__ + "img/lqback.0febd33a.svg";